import { msg } from 'gt-react';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';
import { Route as pathlessAuthenticatedRoute } from '../route';

const SharedLinksPage = lazyRouteComponent(
  () => import('./SharedLinksPage'),
  'SharedLinksPage',
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/shared-links',
  component: SharedLinksPage,
  loader: () => ({
    crumb: msg('Shared Links', { context: 'page breadcrumb' }),
  }),
  validateSearch: z.object({
    tab: z.enum(['my-links', 'shared-with-me']).prefault('my-links'),
  }),
});
